import dark from "./dark";
import light from "./light";

export const BaseTheme = {};

export const THEME_MAP = {
  dark,
  light,
};
